// extracted by mini-css-extract-plugin
module.exports = {"banned":"ModerationActionBanContainer-banned-3iJX-","banIcon":"ModerationActionBanContainer-banIcon-2kv2b","spinner":"ModerationActionBanContainer-spinner-3PQ2P"};